<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">メッセージ</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>お店のコメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.comment.text"
                      :rules="items.comment.rules"
                    >
                      <v-textarea
                        ref="comment"
                        v-model="cast_prop.comment"
                        name="comment"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.comment.text"
                        rows="8"
                        outlined
                        :counter="items.comment.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">セラピストからのメッセージ</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>セラピストコメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.additional_info.text"
                      :rules="items.additional_info.rules"
                    >
                      <v-textarea
                        ref="additional_info"
                        v-model="cast_prop.additional_info"
                        name="additional_info"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.additional_info.text"
                        rows="8"
                        outlined
                        :counter="items.additional_info.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold"
                  >女の子本人のツイッター</span
                ></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.twitter_url.text"
                      :rules="items.twitter_url.rules"
                    >
                      <v-text-field
                        ref="twitter_url"
                        v-model="cast_prop.twitter_url"
                        name="twitter_url"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.twitter_url.text"
                        persistent-hint
                        outlined
                        hint="https://twitter.com/**** または @****(5文字〜15文字) の形式で入力"
                        :counter="items.twitter_url.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold"
                  >女の子本人のYouTubeチャンネル</span
                ></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.youtube_url.text"
                      :rules="items.youtube_url.rules"
                    >
                      <v-text-field
                        ref="youtube_url"
                        v-model="cast_prop.youtube_url"
                        name="youtube_url"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.youtube_url.text"
                        persistent-hint
                        outlined
                        hint="https://www.youtube.com/**** の形式で入力"
                        :counter="items.youtube_url.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold"
                  >女の子本人のインスタグラム</span
                ></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.instagram_url.text"
                      :rules="items.instagram_url.rules"
                    >
                      <v-text-field
                        ref="instagram_url"
                        v-model="cast_prop.instagram_url"
                        name="instagram_url"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.instagram_url.text"
                        persistent-hint
                        outlined
                        hint="https://instagram.com/**** の形式で入力"
                        :counter="items.instagram_url.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">女の子本人のブログ</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.blog_url.text"
                      :rules="items.blog_url.rules"
                    >
                      <v-text-field
                        ref="blog_url"
                        v-model="cast_prop.blog_url"
                        name="blog_url"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.blog_url.text"
                        persistent-hint
                        outlined
                        hint="https://**** の形式で入力"
                        :counter="items.blog_url.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";
import selectItem from "@/common/selectItem.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
    });

    const items = {
      "comment": {
        text: "お店のコメント",
        rules: "max:10000",
        counter: "10000",
      },
      "additional_info": {
        text: "女の子のコメント",
        rules: "max:10000",
        counter: "10000",
      },
      "twitter_url": {
        text: "女の子本人のツイッター",
        rules: "max:200|es_maniax_twitter_url",
        counter: "200",
      },
      "youtube_url": {
        text: "女の子本人のYouTubeチャンネル",
        rules: "max:200|es_maniax_youtube_url",
        counter: "200",
      },
      "instagram_url": {
        text: "女の子本人のインスタグラム",
        rules: "max:200|es_maniax_instagram_url",
        counter: "200",
      },
      "blog_url": {
        text: "女の子本人のブログ",
        rules: "max:200|url_https",
        counter: "200",
      },
    };

    const init = async () => {
      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        set(state.cast_prop, key, props.com_data.cast_prop[key]);
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);
    };

    init();

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      state.errorElement = null;
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(items, item_name);
        state.errorElement = ctx.refs[errorKey].$el;
      }
      return isValid;
    };

    const setErrorFocus = async () => {
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    const save = async () => {
      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:cast_manager_wordpress.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      setting,
      items,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
    };
  },
});
</script>

<style scoped></style>
